//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function (module) {
    
    //Use strict mode
    'use strict';

    /**
     * Class implementing the suscribe/publish pattern, adapted from 
     * http://dev.housetrip.com/2014/09/15/decoupling-javascript-apps-using-pub-sub-pattern/
     */
    module.EventManager = function() {
        this._events = {}; //variable storing the registered events and their associated listeners (= callbacks)
        this._config = undefined;
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} config - Configuration of the class instance
     */
    module.EventManager.prototype.init = function(config) {
        // nothing to do for the moment
        this._config = config;
    };

    /**
     * Class destructor
     */
    module.EventManager.prototype.destroy = function() {
        // nothing to do for the moment
    };

    /**
     * Function registering a new listener for a given event
     * 
     * @param {String} event - Name of the event
     * @param {Function} callback - Callback function to be called each time the event is fired
     * @param {Object} thisObject - Object to use as 'this' in the callback function
     */
    module.EventManager.prototype.register = function(event, callback, thisObject) {
        if(!this._events[event]) this._events[event] = [];
        this._events[event].push({
            callback: callback,
            thisObject: thisObject
        });
    };

    /**
     * Function unregistering a registered listener for a given event
     * 
     * @param {String} event - Name of the event
     * @param {Function} callback - Callback function to be detached from the event (optional, in case no callback
     *      is specified, all callbacks associated with the specified event will be detached from this event)
     * @param {Object} thisObject - Object which is used as 'this' in the callback function (optional, needs to be
     *      specified only in case the same callback was registered with multiple 'this' objects linked to it)
     */
    module.EventManager.prototype.unregister = function(event, callback, thisObject) {
        var listeners = this._events[event];
        if (listeners == undefined || listeners.length == 0) {
            return;
        } else if (callback == undefined) {
            delete this._events[event];
        } else {
            var iListener = 0;
            while (iListener < listeners.length) {
                var listener = listeners[iListener];
                if (callback === listener.callback && (thisObject == undefined || thisObject === listener.thisObject)) {
                    listeners.splice(iListener, 1);
                } else {
                    ++iListener;
                }
            }
        }
    };
    
    /**
     * Function triggering the fire of an event
     * 
     * @param {String} event - Name of the event to fire
     * @param {Object} param - Object containing the list of parameters to be passed to the 
     *      callbacks linked to the event 
     */
    module.EventManager.prototype.trigger = function(event) {
        if(!this._events[event] || this._events[event].length == 0) return;

        var _oArgsA = Array.prototype.slice.call(arguments);
        _oArgsA.shift(); // ignore the first value

        var _this = this;
        this._events[event].forEach(function(listener) {
            listener.thisObject ? listener.callback.apply(listener.thisObject, _oArgsA) : listener.callback.apply(_this, _oArgsA);
        });
    };

    return module;
    
})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.EventManager
     *
     * @param {Object} config - Configuration of the new instance
     * @return {am.EventManager} - New instance of class am.EventManager
     */
    module.eventManager = function(config) {
        var manager = new am.EventManager();
        manager.init(config);
        return manager;
    };

    return module;

})(am.utils || {});